import axios from '../../axios'

/**
 * 查询赛事的项目种类
 * @returns {Promise | Promise<unknown>}
 */
export const list = () => {
  return axios({
    url: '/match/program/list/',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/match/matchProgram.js